// TypeScript port of src/pwhlstats/web/predicates.py.
//
// Mirrors the Python module verbatim — function names, parameter defaults,
// and emitted SQL must stay byte-identical so tests/test_filter_port.py
// can assert parity over a golden corpus of filter dicts.
//
// Conventions match the Python source:
//   - Functions return a SQL fragment usable inside `WHERE ... AND <fragment>`.
//   - `events_alias` / `chain_alias` default to 'e' / 'pc'.
//   - Constants (rebound window, etc.) live here so a tuning change happens
//     in one place.

// A "rebound" is an outcome event preceded by a same-team shot/goal in the
// same zone within this many seconds.
export const REBOUND_WINDOW_SECONDS = 3;

// Allowed season-type values for the splash + play-index toggles. None /
// "all" both mean no filter.
export const SEASON_TYPE_OPTIONS = ["all", "regular", "playoff", "preseason"] as const;

export function inSeason(
  seasonType: string | null | undefined,
  gameIdExpr: string = "e.game_id",
): string {
  if (!seasonType || seasonType === "all") return "1=1";
  let clause: string;
  if (seasonType === "regular") {
    clause = "(g_st.season_type = 'regular' OR g_st.season_type IS NULL)";
  } else if (seasonType === "playoff" || seasonType === "preseason") {
    clause = `g_st.season_type = '${seasonType}'`;
  } else {
    return "1=1";
  }
  return (
    "EXISTS (SELECT 1 FROM games g_st " +
    `WHERE g_st.game_id = ${gameIdExpr} AND ${clause})`
  );
}

export function isRebound(eventsAlias: string = "e"): string {
  const e = eventsAlias;
  return (
    "EXISTS (SELECT 1 FROM events r " +
    `WHERE r.game_id = ${e}.game_id ` +
    "AND r.event_type IN ('shot','goal') " +
    `AND r.team_id = ${e}.team_id AND r.zone = ${e}.zone ` +
    `AND r.clock_seconds_elapsed < ${e}.clock_seconds_elapsed ` +
    `AND (${e}.clock_seconds_elapsed - r.clock_seconds_elapsed) ` +
    `<= ${REBOUND_WINDOW_SECONDS})`
  );
}

export function chainStartedOffRush(
  value: boolean = true,
  chainAlias: string = "pc",
): string {
  return `${chainAlias}.started_off_rush = ${value ? 1 : 0}`;
}

export function chainStartedOffFaceoff(
  value: boolean = true,
  chainAlias: string = "pc",
): string {
  return `${chainAlias}.started_off_faceoff = ${value ? 1 : 0}`;
}

export function lateGame(eventsAlias: string = "e"): string {
  return `${eventsAlias}.late_game = 1`;
}
